const firebaseConfigProduction = {
  apiKey: 'AIzaSyCY6cZDRyUmvV6YGl1MZCm5mWhJ92R6b0E',
  authDomain: 'between-worlds.firebaseapp.com',
  databaseURL: 'https://between-worlds.firebaseio.com',
  projectId: 'between-worlds',
  storageBucket: 'between-worlds.appspot.com',
  messagingSenderId: '886866346913',
  appId: '1:886866346913:web:588845d293da1637',
};

const firebaseConfigDevelopment = {
  apiKey: 'AIzaSyAG_Cb96nD9rP6k-3wpprKfRSyRcAs6UTM',
  authDomain: 'between-worlds-dev.firebaseapp.com',
  databaseURL: 'https://between-worlds.firebaseio.com', // Same as prod
  projectId: 'between-worlds-dev',
  storageBucket: 'between-worlds-dev.appspot.com',
  messagingSenderId: '514203737265',
  appId: '1:514203737265:web:26a91ca163136c475a9690',
};

export const firebaseConfig =
  import.meta.env.VITE_ENVIRONMENT === 'production' || import.meta.env.VITE_ENVIRONMENT === 'test'
    ? firebaseConfigProduction
    : firebaseConfigDevelopment;

export const publicImageURL =
  import.meta.env.VITE_ENVIRONMENT === 'production' || import.meta.env.VITE_ENVIRONMENT === 'test'
    ? 'https://storage.googleapis.com/between-worlds.appspot.com/images/'
    : 'https://storage.googleapis.com/between-worlds-dev.appspot.com/images/';
